import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User } from '@api/models/user.model';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { ShowResponse, IndexResponse } from '@api/models/response.model';
import { AdminBaseService } from './admin-base.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends AdminBaseService {
  constructor() {
    super('users');
  }

  getUsers(page: number = 1): Observable<IndexResponse<User>> {
    return this.http.get<IndexResponse<User>>(`${this.apiUrl}?page=${page}`);
  }

  getUser(id: string): Observable<User> {
    return this.http.get<ShowResponse<User>>(`${this.apiUrl}/${id}`).pipe(
      map((response) => response.data)
    );
  }

  createUser(user: User): Observable<User> {
    return this.http.post<ShowResponse<User>>(`${this.apiUrl}`, user).pipe(
      map((response) => response.data)
    );
  }

  updateUser(id: string, user: User): Observable<User> {
    return this.http.put<ShowResponse<User>>(`${this.apiUrl}/${id}`, user).pipe(
      map((response) => response.data)
    );
  }

  deleteUser(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  resendInvite(id: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/resend-invite`, {});
  }

  reset2FA(id: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/reset-2fa`, {});
  }
}
